// This file is auto generated!
// Please do not edit manually
// Run 'npm run generate:icons' to regenerate this file.
export const SUPPORT_CHEVRONRIGHT = {
    name: 'chevronright',
    source: `<svg><defs/><symbol id="chevronright" viewBox="0 0 13 24">
    <!-- Generator: Sketch 3.8.3 (29802) - http://www.bohemiancoding.com/sketch -->
    <title>XMLID_60_</title>
    <desc>Created with Sketch.</desc>
    
    <g id="Page-1" stroke="none" stroke-width="1" fill="currentColor" fill-rule="evenodd">
        <g id="export-artboard" transform="translate(-6.000000, 0.000000)" fill="currentColor">
            <g id="Arrow_forward_VF_icon_V1.1" transform="translate(6.000000, 0.000000)">
                <path d="M1.09827586,23.8415094 C0.874137931,23.8415094 0.65,23.7509434 0.470689655,23.5698113 C0.112068966,23.2075472 0.112068966,22.6415094 0.470689655,22.2792453 L10.7137931,11.9320755 L0.448275862,1.60754717 C0.0896551724,1.24528302 0.0896551724,0.679245283 0.448275862,0.316981132 C0.806896552,-0.0452830189 1.36724138,-0.0452830189 1.72586207,0.316981132 L12.6189655,11.3207547 C12.7982759,11.5018868 12.887931,11.7283019 12.887931,11.954717 C12.887931,12.1811321 12.7982759,12.4301887 12.6189655,12.5886792 L1.74827586,23.5698113 C1.56896552,23.7509434 1.34482759,23.8415094 1.09827586,23.8415094 L1.09827586,23.8415094 Z" id="XMLID_60_"/>
            </g>
        </g>
    </g>
</symbol></svg>`,
};
//# sourceMappingURL=chevronright.js.map